var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomFax = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5V1L22 .5l.5 10h-18z",
    stroke: "#1E2969",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#8CBAC7",
    y: 10,
    width: 26,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1E2969",
    x: 7,
    y: 3,
    width: 13,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1E2969",
    x: 7,
    y: 5,
    width: 13,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1E2969",
    x: 7,
    y: 7,
    width: 13,
    height: 1,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.048 22.273c.197-.28.403-1.188.348-1.787a6.857 6.857 0 0 1-.034-.496c.225-.116.463-.218.708-.3a5.964 5.964 0 0 1 3.878 0c.245.082.483.184.708.3-.007.17-.027.408-.04.503-.055.599.144 1.5.341 1.78.408.585 3.332.506 3.36.506.292.048.592-.034.823-.224.53-.53.082-4.028-.252-4.362-.02-.02-2.007-1.952-6.892-1.993-4.872.04-6.859 1.973-6.88 1.993-.333.334-.789 3.824-.251 4.362.245.19.544.272.83.218.048-.007 2.951.092 3.353-.5z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomFax);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-fax.3d96937899445b977a711378edd30a6a.svg";